import { useCallback, useRef } from 'react'

import { useAuthMember } from '@tribeplatform/react-sdk/hooks'

import { useQuery } from '../../../../hooks/useQuery.js'
import { useSegment } from '../../../../providers/SegmentProvider.js'
import {
  CheckoutCompletedQueryParams,
  SegmentCheckoutCompletedEventProps,
} from '../types.js'

export const useTrackCheckoutCompleted = () => {
  const { planId, planName, planAmount, planInterval, sessionId, success } =
    useQuery<CheckoutCompletedQueryParams>()

  const segment = useSegment()
  const tracked = useRef(false)

  const { data: member } = useAuthMember()
  const { email, name } = member || {}

  const isSuccessful = success === 'true'

  const trackCheckoutCompleted = useCallback(async () => {
    tracked.current = true
    if (!isSuccessful) {
      return
    }

    const amount = Number.parseInt(planAmount, 10)
    const eventProps: SegmentCheckoutCompletedEventProps = {
      email,
      name,
      plan_id: planId,
      plan_name: planName,
      plan_amount: amount,
      plan_amount_whole: Math.floor(amount / 100),
      plan_interval: planInterval,
      checkout_session_id: sessionId,
    }

    await segment.identify({ email, name })
    await segment.track('Checkout Completed', eventProps)
  }, [
    email,
    name,
    segment,
    planId,
    planName,
    planAmount,
    planInterval,
    sessionId,
    isSuccessful,
  ])

  const trackCheckoutCompletedOnce = useCallback(async () => {
    if (tracked.current) {
      return
    }

    await trackCheckoutCompleted()
  }, [trackCheckoutCompleted])

  return {
    trackCheckoutCompleted,
    trackCheckoutCompletedOnce,
  }
}
